import {
  MapPlaceSuggestion,
  BaseMapOptions,
  HexBinClassBreaks,
  GeoscapeAddress,
  LandParcelType
} from 'types';

interface ActionTypes {
  GET_GEOCODE_START: string;
  GET_GEOCODE_SUCCESS: string;
  GET_GEOCODE_FAILURE: string;
  CLEAR_GEOCODE: string;
  GET_PLACE_SUGGESTION_START: string;
  GET_PLACE_SUGGESTION_SUCCESS: string;
  GET_PLACE_SUGGESTION_FAILURE: string;
  CLEAR_PLACE_SUGGESTION: string;
  GET_BASE_MAPS_START: string;
  GET_BASE_MAPS_SUCCESS: string;
  GET_BASE_MAPS_FAILURE: string;
  CLEAR_BASE_MAPS: string;
  QUERY_FEATURE_LAYER_EXTENT_START: string;
  QUERY_FEATURE_LAYER_EXTENT_SUCCESS: string;
  QUERY_FEATURE_LAYER_EXTENT_FAILURE: string;
  CLEAR_FEATURE_LAYER_EXTENT: string;
  QUERY_FEATURE_LAYER_FEATURES_START: string;
  QUERY_FEATURE_LAYER_FEATURES_SUCCESS: string;
  QUERY_FEATURE_LAYER_FEATURES_FAILURE: string;
  CLEAR_FEATURE_LAYER_FEATURES: string;
  GET_HEXBIN_CLASS_BREAKS_START: string;
  GET_HEXBIN_CLASS_BREAKS_SUCCESS: string;
  GET_HEXBIN_CLASS_BREAKS_FAILURE: string;
  GET_PLACE_ADDRESS_CANDIDATE_START: string;
  GET_PLACE_ADDRESS_CANDIDATE_SUCCESS: string;
  GET_PLACE_ADDRESS_CANDIDATE_FAILURE: string;
  CLEAR_PLACE_ADDRESS_CANDIDATE: string;
  GET_GEOSCAPE_ADDRESS_START: string;
  GET_GEOSCAPE_ADDRESS_SUCCESS: string;
  GET_GEOSCAPE_ADDRESS_FAILURE: string;
  GET_GEOSCAPE_LAND_PARCEL_START: string;
  GET_GEOSCAPE_LAND_PARCEL_SUCCESS: string;
  GET_GEOSCAPE_LAND_PARCEL_FAILURE: string;
  CLEAR_GEOSCAPE_ADDRESS: string;
  CLEAR_GEOSCAPE_LAND_PARCEL: string;
  SET_IS_OPEN_BASE_MAP_PANEL: string;
  SET_MAP_SEARCH_WITH_EXTENT_ZOOM: string;
}

export const MapActionTypes: ActionTypes = {
  GET_GEOCODE_START: '@@GET_GEOCODE_START',
  GET_GEOCODE_SUCCESS: '@@GET_GEOCODE_SUCCESS',
  GET_GEOCODE_FAILURE: '@@GET_GEOCODE_FAILURE',
  CLEAR_GEOCODE: '@@CLEAR_GEOCODE',
  GET_PLACE_SUGGESTION_START: '@@GET_PLACE_SUGGESTION_START',
  GET_PLACE_SUGGESTION_SUCCESS: '@@GET_PLACE_SUGGESTION_SUCCESS',
  GET_PLACE_SUGGESTION_FAILURE: '@@GET_PLACE_SUGGESTION_FAILURE',
  CLEAR_PLACE_SUGGESTION: '@@CLEAR_PLACE_SUGGESTION',
  GET_BASE_MAPS_START: '@@GET_BASE_MAPS_START',
  GET_BASE_MAPS_SUCCESS: '@@GET_BASE_MAPS_SUCCESS',
  GET_BASE_MAPS_FAILURE: '@@GET_BASE_MAPS_FAILURE',
  CLEAR_BASE_MAPS: '@@CLEAR_BASE_MAPS',
  QUERY_FEATURE_LAYER_EXTENT_START: '@@QUERY_FEATURE_LAYER_EXTENT_START',
  QUERY_FEATURE_LAYER_EXTENT_SUCCESS: '@@QUERY_FEATURE_LAYER_EXTENT_SUCCESS',
  QUERY_FEATURE_LAYER_EXTENT_FAILURE: '@@QUERY_FEATURE_LAYER_EXTENT_FAILURE',
  CLEAR_FEATURE_LAYER_EXTENT: '@@CLEAR_FEATURE_LAYER_EXTENT',
  QUERY_FEATURE_LAYER_FEATURES_START: '@@QUERY_FEATURE_LAYER_FEATURES_START',
  QUERY_FEATURE_LAYER_FEATURES_SUCCESS:
    '@@QUERY_FEATURE_LAYER_FEATURES_SUCCESS',
  QUERY_FEATURE_LAYER_FEATURES_FAILURE:
    '@@QUERY_FEATURE_LAYER_FEATURES_FAILURE',
  CLEAR_FEATURE_LAYER_FEATURES: '@@CLEAR_FEATURE_LAYER_FEATURES',
  GET_HEXBIN_CLASS_BREAKS_START: '@@GET_HEXBIN_CLASS_BREAKS_START',
  GET_HEXBIN_CLASS_BREAKS_SUCCESS: '@@GET_HEXBIN_CLASS_BREAKS_SUCCESS',
  GET_HEXBIN_CLASS_BREAKS_FAILURE: '@@GET_HEXBIN_CLASS_BREAKS_FAILURE',
  GET_PLACE_ADDRESS_CANDIDATE_START: '@@GET_PLACE_ADDRESS_CANDIDATE_START',
  GET_PLACE_ADDRESS_CANDIDATE_SUCCESS: '@@GET_PLACE_ADDRESS_CANDIDATE_SUCCESS',
  GET_PLACE_ADDRESS_CANDIDATE_FAILURE: '@@GET_PLACE_ADDRESS_CANDIDATE_FAILURE',
  CLEAR_PLACE_ADDRESS_CANDIDATE: '@@CLEAR_PLACE_ADDRESS_CANDIDATE',
  GET_GEOSCAPE_ADDRESS_START: '@@GET_GEOSCAPE_ADDRESS_START',
  GET_GEOSCAPE_ADDRESS_SUCCESS: '@@GET_GEOSCAPE_ADDRESS_SUCCESS',
  GET_GEOSCAPE_ADDRESS_FAILURE: '@@GET_GEOSCAPE_ADDRESS_FAILURE',
  GET_GEOSCAPE_LAND_PARCEL_START: '@@GET_GEOSCAPE_LAND_PARCEL_START',
  GET_GEOSCAPE_LAND_PARCEL_SUCCESS: '@@GET_GEOSCAPE_LAND_PARCEL_SUCCESS',
  GET_GEOSCAPE_LAND_PARCEL_FAILURE: '@@GET_GEOSCAPE_LAND_PARCEL_FAILURE',
  CLEAR_GEOSCAPE_ADDRESS: '@@CLEAR_GEOSCAPE_ADDRESS',
  CLEAR_GEOSCAPE_LAND_PARCEL: '@@CLEAR_GEOSCAPE_LAND_PARCEL',
  SET_IS_OPEN_BASE_MAP_PANEL: '@@SET_IS_OPEN_BASE_MAP_PANEL',
  SET_MAP_SEARCH_WITH_EXTENT_ZOOM: '@@SET_MAP_SEARCH_WITH_EXTENT_ZOOM'
};

export interface MapState {
  geocode: any;
  suggestion: MapPlaceSuggestion[];
  suggestionError: string;
  basemapOptions: BaseMapOptions;
  basemapError: string;
  featureLayerExtent: any;
  featureLayerfeatures: __esri.Graphic[] | string | null;
  addressCandidate?: __esri.AddressCandidate[] | null;
  addressCandidateError?: string;
  geoscapeAddress?: GeoscapeAddress;
  landParcel?: LandParcelType;
  geoscapeAddressError?: string;
  IsOpenBaseMapPanel?: boolean;
  mapSearchWithExtentZoom: boolean[];
  hexbinClassBreaks?: HexBinClassBreaks;
}

export interface ArcGISWorldGeocodingSuggestionDataModel {
  text: string;
  magicKey: string;
  isCollection: boolean;
}

export default MapActionTypes;
